import React, { Fragment, useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { getCollectionitems } from "../../../../../api/utils";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { replaceWithAlternates } from "../../../utils";
import { getStoryHeadline, getStoryLabel } from "../../../utils/story";
import get from "lodash/get";

import { Label } from "../../../atoms/Label";
import { HeroImage } from "../../../atoms/HeroImage";
import Headline from "../../../atoms/Headline";

import "./trending-stories.m.css";

export default function TrendingStories() {
  const [trendingStories, setTrendingStories] = useState([]);
  useEffect(() => {
    getCollectionitems("trending-stories", 0, 3).then((response) => {
      setTrendingStories(response?.items);
    });
  }, []);

  return (
    trendingStories?.length > 0 && (
      <div styleName="trending-stories-img-wrapper">
        <p styleName="title">Trending Stories</p>
        <div styleName="story-row">
          {trendingStories.map((groupItem, index) => {
            const { story } = groupItem;
            const label = getStoryLabel(story);
            const alternateStory = replaceWithAlternates(story);
            const headline = getStoryHeadline(story);
            const imageUrl =
              get(story, ["hero-image-s3-key"], "") ||
              get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");
            return (
              <Fragment key={index}>
                <Link href={`/${story?.slug}`}>
                  <HeroImage
                    story={story}
                    headline={headline}
                    aspectRatio={[[4, 3]]}
                    iconSizes={{ height: 24, width: 24 }}
                    imageUrl={imageUrl}
                    defaultWidth={175}
                  />
                  <div styleName="card-details">
                    {label && <Label story={story} />}
                    {alternateStory?.headline && <Headline headline={alternateStory?.headline} styleName="headline" />}
                    <PublishAndReadTime story={story} showReadTime={true} showTimestamp={true} />
                  </div>
                </Link>
              </Fragment>
            );
          })}
        </div>
      </div>
    )
  );
}
